import { render, staticRenderFns } from "./xw.vue?vue&type=template&id=a458f6cc&scoped=true"
import script from "./xw.vue?vue&type=script&lang=js"
export * from "./xw.vue?vue&type=script&lang=js"
import style0 from "./xw.vue?vue&type=style&index=0&id=a458f6cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a458f6cc",
  null
  
)

export default component.exports